import type { MouseEvent, ReactNode } from 'react';

interface ButtonProps {
  children: ReactNode;
  clickEvent: (event: MouseEvent<HTMLButtonElement>) => void;
  modifier?: string;
  ariaLabel?: string;
}

const Button = ({ children, clickEvent, modifier, ariaLabel }: ButtonProps) => {
  return (
    <div className={`Button-container ${modifier || ''}`}>
      <button
        type="button"
        className="Button-inner"
        onClick={(e) => {
          clickEvent(e);
        }}
        aria-label={ariaLabel}
      >
        {children}
      </button>
    </div>
  );
};

export default Button;
